/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components'

export const FormCommentStyled = styled.div`
  display: block;
  max-width: 100%;
  margin-bottom: 8px;
  button:first-child {
    margin-right: 16px;
    border: 1px solid;
    color: var(--baseSecondary);
    opacity: 0.8;
    border-color: var(--gray);
  }
  .mardown-activated {
    font: var(--smallRegular);
    opacity: 0.7;
    margin-block-start: -12px;
    margin-inline-start: 48px;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
  @media screen and (min-width: 768px) {
    margin-bottom: 24px;
    .mardown-activated {
      margin-block-start: 4px;
    }
  }
`

export const FormStyled = styled.form`
  align-items: flex-start;
  background-color: var(--sky);
  padding: 1em 0;
  &, textarea {
    display: flex;
    flex: 1;
    font-size: 16px;
    border-radius: 0;
  }

  .submit {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    border: none;
    background: none;
    appearance: none;
    flex-shrink: 0;
  }
  textarea {
    color: var(--neutralText);
    background-color: var(--sky);
    line-height: 24px;
    font-family: var(--primaryFont);
    outline: 0;
    resize: none;
    border: none;
    align-items: center;
  }
  .avatar {
    display: flex;
    flex-shrink: 0;
    img {
      border-radius: 50%;
      object-fit: cover;
      margin-right: 6px;
      margin-bottom: 2.5px;
      background-color: var(--primary);
    }
  }
  .icon {
    align-self: ${({ size }) => (size < 40 ? 'center' : 'flex-end')};
    color: var(--primary);
    font-size: 22px;
    margin-left: 15px;
  }
  ${
  (
    {
      size,
      focusOnMobile,
      visualViewport,
    },
  ) => focusOnMobile && css`
    & {
      padding: 1em 1em;
      position: fixed;
      top: ${`${visualViewport - size}`}px;
      left: 0;
      right: 0;
      background: var(--sky);
      z-index: 5;
      box-shadow: 0 0 10px rgba(0,0,0,.2);
    }
    textarea {
      background: var(--sky);
      border-radius: 0;
      border: none;
    }
    .submit {
      align-self: flex-end;
    }
  `}
  @media screen and (min-width: 768px) {
    position: static;
    padding: 0;
    box-shadow: none;
    .icon {
      margin-left: 0;
      display: none;
    }
    textarea {
      background-color: var(--basePrimary);
      padding: 12px 16px;
      border-radius: 8px;
    }
    .submit {
      display: none;
    }
  }
`